import { FC } from 'react';
import { DailyDealStoryblok } from 'storyblok-types';
import { Button } from 'atoms/Button';
import { Image } from 'atoms/Image/Image';
import { renderLink } from 'atoms/StoryBlokLink';
import styles from './styles.module.css';

export const DailyDeal: FC<{ data: DailyDealStoryblok }> = ({ data }) => {
  return (
    <div className={styles.root} data-testid="tip">
      <Image
        src={data.background?.filename}
        alt={data.background?.alt}
        className={styles.img}
      />
      <Button
        href={renderLink(data?.link)}
        style={{
          color: data?.button_text_color?.color,
          backgroundColor: data?.button_background?.color,
        }}
        className={styles.button}
      >
        {data.button_text}
      </Button>
    </div>
  );
};
